import React, { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'
import { CenterContainer } from '../Styles/CustomElementsStyled'
import { CircularProgress } from '@mui/material'
import { themeColors } from '../../const/colors'
import { TextH6Bold } from '../Styles/TextCustom'

const FullScreenLoader = ({ children }: PropsWithChildren<{}>) => {
  return (
    <CenterContainer>
      {children && <LoaderText>{children}</LoaderText>}
      <CustomProgress size={50} />
    </CenterContainer>
  )
}

const LoaderText = styled(TextH6Bold)`
  padding-bottom: 40px;
`
const CustomProgress = styled(CircularProgress)`
  color: ${themeColors.primary};
  margin: 16px;
`

export default FullScreenLoader
